import React, { Component } from "react";

class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    };
    this.img = React.createRef();
  }
  handleImageLoading = () => {
    this.setState({
      width: this.img.current.naturalWidth / 2,
    });
  };
  componentDidMount() {
    const img = this.img.current;
    if (img && img.complete) {
      this.handleImageLoading();
    }
  }
  render() {
    return (
      <img
        ref={this.img}
        src={this.props.src}
        className={this.props.className ? this.props.className : null}
        alt={this.props.alt ? this.props.alt : null}
        onLoad={this.handleImageLoading}
        style={{
          maxWidth: this.state.width,
        }}
        {...(this.props.draggable !== undefined && {
          draggable: this.props.draggable,
        })}
      />
    );
  }
}

export default Image;
